<div class="card">
    <div class="card-header">
      <h4>Reconciliation Report</h4>
    </div>
    <div class="card-body m-0">
      <div class="row mb-2">
        <div class="col-xl-10">
            <div class="row">
                <!-- <div class="col-sm-4">
                  <label class="col-form-label" for="customerMobile">Organization Mobile
                  </label>
      
                  <div class="row">
                    <div class="col-sm-9">
                      <input class="form-control" id="customerMobile" [(ngModel)]="customerMobile"  type="number" autocomplete="new-password"
                       name="customerMobile">
                    </div>
                  </div>
                </div> -->
      
                <div class="col-sm-4">
                    <label class="col-form-label" for="dateFrom">Select Date</label>
                    <div class="col-sm-9">
                  
                          <input #filSearchFromDate [(ngModel)]="dateFrom" name="dateFrom" class="form-control" id="dateFrom"
                            max="{{currentDate|date:'yyyy-MM-dd'}}" (change)="changeDate()" type="date" />
                   
                    </div>
                  </div>
      
            </div>
            <br>
            <div class="text-start">
               
                    <button type="button" class="btn bg-danger-custom" (click)="onSearchPayments()">Search<i class="feather icon-search"></i></button>
       
                    <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()">Export Excel<i class="feather icon-download"></i></button>
        
                  
                        <div class="btn-group" ngbDropdown role="group">
                          <button class="btn bg-danger-custom" ngbDropdownToggle>Columns</button>
                          <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                            style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                            <div class="form-group">
                              <!--            <label for="columns" class="form-label"> All Columns</label>-->
                              <div *ngIf="columnDefs" class="list-group ng-option">
                                <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                                  <label class="list-group-item p-2">
                                    <input class="form-check-input me-1" type="checkbox" style="margin-left: 180px;" value="{{i}}" name="{{column.headerName}}"
                                      (change)="updateSelectedColumn($event)"
                                      [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                                    {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                                  </label>
                                </span>
                              </div>
              
                            </div>
                            <!--          <ng-select-->
                            <!--            [(ngModel)]="tableSelectedColumn"-->
                            <!--            [closeOnSelect]="false"-->
                            <!--            [items]="columnDefs"-->
                            <!--            [multiple]=true-->
                            <!--            bindLabel="field">-->
                            <!--            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>-->
                            <!--              <input [ngModel]="item$.selected" id="item-{{index}}" type="checkbox"/> {{item.field.toUpperCase()}}-->
                            <!--            </ng-template>-->
                            <!--          </ng-select>-->
              
                          </div>
                       
              
            </div>
            <br>
         
          </div>
        </div>
        <!-- <div class="col-xl-2" *ngIf="permissions.includes('View')">
          <input id="typeahead-basic" type="text" autocomplete="new-password" placeholder="Search in page"
            class="form-control" (selectItem)="searchQuickFilter($event)" [(ngModel)]="globalSearch"
            (ngModelChange)="onGlobalSearchChange($event)" [ngbTypeahead]="search" />
        </div> -->
      </div>
  
  
  
      
      <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
      
  
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <!-- <div class="row"> -->
                  <label class="col-form-label" for="searchMerName">Search by Legal Name</label>
                  <!-- <div class="col-md-8"> -->
                  <!-- <input (keyup.enter)="onSearchBtnClick($event)" [(ngModel)]="searchMerName" class="form-control"
                  maxlength="50" id="searchMerName" (keyup)="allowAlfanumeric($event)"
                  (keypress)="OnlyCharacterAllowed($event)" (change)="allowAlfanumeric($event)" type="text" autocomplete="new-password" />
               -->
  
                  <ng-select #filSearchMerName (keyup.enter)="onSearchBtnClick($event)" [(ngModel)]="searchMerName"
                    id="searchMerName" (keyup)="allowAlfanumeric($event)" (keypress)="OnlyCharacterAllowed($event)"
                    (change)="allowAlfanumeric($event)" placeholder="Search by Legal Name"
                    [inputAttrs]="{maxlength: '200'}" (focus)="fun('searchMerName')"
                    (focusout)="funover('searchMerName')">
                    <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.merchant_name">
                      {{merchant.merchant_name}}
                    </ng-option>
                  </ng-select>
  
                  <!-- </div> -->
  
                  <!-- </div> -->
                </div>
                <div class="col-md-4">
                  <!-- <div class="row"> -->
                  <label class="col-form-label" for="searchMID">Search by Merchant ID</label>
                  <!-- <div class="col-md-8"> -->
  
                  <!-- <input (keyup.enter)="onSearchBtnClick($event)" [(ngModel)]="searchMID" class="form-control"
                  id="searchMID" maxlength="10" (keyup)="allowAlfanumeric($event)" (change)="allowAlfanumeric($event)"
                  type="text" autocomplete="new-password" /> -->
  
                  <ng-select #filSearchMID [(ngModel)]="searchMID" id="searchMID" placeholder="Merchant Id"
                    [inputAttrs]="{maxlength: '100'}" (focus)="fun('searchMID')" (focusout)="funover('searchMID')">
                    <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                      {{merchant.merchant_name}} ({{merchant.MerchantId}})
                    </ng-option>
                  </ng-select>
  
  
                  <!-- <ng-select [items]="Resultdata" bindLabel="FieldValue" bindValue="FieldValue" [(ngModel)]="searchMID"
                  id="searchMID" placeholder="Merchant Id">
                  <ng-template ng-option-tmp let-item="item">
                    <div title="{{item.FieldValue}}">{{item.FieldValue}}</div>
                  </ng-template>
                </ng-select> -->
                  <!-- </div> -->
                  <!-- </div> -->
                </div>
  
                <div class="col-md-4">
  
                  <label class="col-form-label" for="resellerPartnerId">Reseller</label>
  
                  <!-- <ng-select [items]="resellerListOptions" bindLabel="FieldText" bindValue="FieldValue"
                  [(ngModel)]="resellerPartnerId" placeholder="Select Reseller Partner" required [inputAttrs]="{maxlength: '100'}">
                </ng-select> -->
                  <ng-select #filResellerPartnerId [(ngModel)]="resellerPartnerId" id="resellerPartnerId"
                    placeholder="Select Reseller Partner" [inputAttrs]="{maxlength: '100'}"
                    (focus)="fun('resellerPartnerId')" (focusout)="funover('resellerPartnerId')">
                    <ng-option *ngFor="let RESELLER of resellerListOptions" [value]="RESELLER.FieldValue">
                      {{RESELLER.FieldText}} ({{RESELLER.FieldValue}})
                    </ng-option>
                  </ng-select>
  
                </div>
              </div>
  
  
              <div class="row">
                <div class="col-md-4">
  
                  <label class="col-form-label" for="resellerPartnerId">Status</label>
  
                  <ng-select #filStatus [items]="merchantStatusdata" bindLabel="FieldText" bindValue="FieldValue"
                    [(ngModel)]="Status" placeholder="Select Status" required [inputAttrs]="{maxlength: '40'}" id="Status"
                    (focus)="fun('Status')" (focusout)="funover('Status')">
                  </ng-select>
  
  
                </div>
  
  
  
                <div class="col-md-4">
                <div class="row">
                  <label class="col-form-label" for="searchMID">Search by Date Range</label>
                  <div class="col-md-6">
                    <input #filSearchFromDate [(ngModel)]="searchFromDate" class="form-control" id="searchFromDate"
                      max="{{searchToDate|date:'yyyy-MM-dd'}}" (change)="changeDate()" type="date" />
                  </div>
                  <div class="col-md-6">
                    <input #filSearchToDate [(ngModel)]="searchToDate" class="form-control" id="searchToDate"
                      min="{{searchFromDate|date:'yyyy-MM-dd'}}" (change)="changeEndDate()" type="date" />
                  </div>
                </div>
              </div>
               
  
  
                <div class="mb-3 col-md-2" style="margin-top: 4%;">
                  <!-- <div class="row"> -->
                  <!-- <div class="col-md-12"> -->
                  <!-- <label class="col-form-label" for="searchMID">Search</label> -->
                  <!-- </div>            -->
                  <!-- <div class="col-md-6"> -->
                  <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom" type="button"><i
                      class="feather icon-search"></i>Search
                  </button>
                  <!-- </div> -->
                  <!-- </div> -->
                </div>
  
              </div>
  
  
            </div>
          </div>
        
      </div>
      <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
            (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)" [rowClassRules]="rowClassRules"
            (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
            (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [columnDefs]="tableSelectedColumn"
            [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [paginationPageSize]="pageSize"
            [pagination]="true" [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>
      <div class="row mt-0">
        <div class="col-4 col-xs-4">
          <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
            <!--          <option [ngValue]="10">10</option>-->
            <!--          <option [ngValue]="20">20</option>-->
            <!--          <option [ngValue]="30">30</option>-->
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
  
          </select>
        </div>
  
        <div class="col-8 col-xs-8">
          <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="maxSize" [pageSize]="pageSize" [rotate]="true"
            [ellipses]="ellipses" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination>
        </div>
  
      </div>
    </div>
  
  </div>
  


 
  